import React from 'react';
import { Content } from './components';
import { CpFilesListView } from './files-list-view';
import { CpFilesSidePane } from './files-side-pane';
import { CpAllFilesProps } from './types';

export const CpAllFilesForMobile: React.FC<CpAllFilesProps> = ({
  search,
  currentFolder,
  onFolderClick,
  data,
  currentAttachments,
  handleDownload,
  onFileClick,
  projectId,
}) => {
  if (!currentFolder) {
    return (
      <CpFilesSidePane
        search={search}
        currentFolder={currentFolder}
        onFolderClick={onFolderClick}
        data={data}
        projectId={projectId}
      />
    );
  }

  return (
    <Content>
      {/* <ContentTitleWrapper>
        <BackIconWrapper
          onClick={() => {
            onFolderClick(undefined);
          }}
        >
          <ChevronLeft16 />
        </BackIconWrapper>
        <ContentTitle>{currentFolder?.folderName}</ContentTitle>
      </ContentTitleWrapper> */}
      <CpFilesListView
        onFileClick={(x) => onFileClick(x?.attachmentId)}
        attachments={currentAttachments}
        onDownload={(a) => handleDownload(a?.attachmentId)}
      />
    </Content>
  );
};
